import { motion } from 'framer-motion';
import { Heart, Linkedin, Globe, Github, Atom } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark-900 border-t border-white/5">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <Atom className="w-8 h-8 text-cyber-blue" />
              <span className="font-display font-bold text-lg">AI Periodic Table</span>
            </div>
            <p className="text-gray-400 text-sm mb-4 max-w-md">
              A comprehensive framework for understanding Artificial Intelligence — 
              168 elements across 11 blocks, from Perceptrons to Superintelligence.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://github.com/sankar-mechengg/ai-periodic-table"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-lg bg-white/5 hover:bg-white/10 transition-colors"
                aria-label="GitHub"
              >
                <Github className="w-5 h-5" />
              </a>
              <a
                href="https://www.linkedin.com/in/sankar4/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-lg bg-white/5 hover:bg-white/10 transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="https://www.sankar.studio"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-lg bg-white/5 hover:bg-white/10 transition-colors"
                aria-label="Personal Website"
              >
                <Globe className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Explore</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#table" className="text-gray-400 hover:text-white transition-colors">
                  Periodic Table
                </a>
              </li>
              <li>
                <a href="#blocks" className="text-gray-400 hover:text-white transition-colors">
                  11 Blocks
                </a>
              </li>
              <li>
                <a href="#timeline" className="text-gray-400 hover:text-white transition-colors">
                  Timeline
                </a>
              </li>
              <li>
                <a href="#future" className="text-gray-400 hover:text-white transition-colors">
                  Future Block
                </a>
              </li>
              <li>
                <a href="#recipes" className="text-gray-400 hover:text-white transition-colors">
                  System Recipes
                </a>
              </li>
              <li>
                <a href="#learn" className="text-gray-400 hover:text-white transition-colors">
                  Learn
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-semibold mb-4">Resources</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a 
                  href="https://github.com/sankar-mechengg/ai-periodic-table"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  GitHub Repository
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-white transition-colors">
                  Contact
                </a>
              </li>
              <li>
                <a 
                  href="https://creativecommons.org/licenses/by/4.0/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  License (CC BY 4.0)
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            {/* Made with Love */}
            <motion.div
              className="flex items-center gap-2 text-sm text-gray-400"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5 }}
            >
              <span>Made with</span>
              <Heart className="w-4 h-4 text-red-500 fill-red-500" />
              <span>by</span>
              <a
                href="https://www.linkedin.com/in/sankar4/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-cyber-blue transition-colors font-medium"
              >
                Sankar Balasubramanian
              </a>
            </motion.div>

            {/* Links */}
            <div className="flex items-center gap-6 text-sm text-gray-500">
              <span>© {currentYear} All rights reserved</span>
              <span className="hidden md:inline">|</span>
              <a href="#" className="hover:text-white transition-colors">
                Terms and Conditions
              </a>
              <a href="#" className="hover:text-white transition-colors">
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
